import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-edbHeaderItems',
  templateUrl: './edbHeaderItems.component.html',
  styleUrls: ['./edbHeaderItems.component.scss'],
})
export class EdbHeaderItemsComponent {
  @Input()
  icon: string;

  @Input()
  tranlationName: string;

  @Input()
  url: string;
}
